import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Text,
  Badge,
  ScrollAreaAutosize,
  SimpleGrid,
  Button,
  Radio,
  Group,
  TagsInput,
  Pagination,
  Paper,
  Loader,
  Switch,
  Code,
  LoadingOverlay,
  Box,
} from "@mantine/core";
import {
  fetchGalleryModerator,
  deleteImage,
  getJobsForResultImage,
  setImageMeta,
  setImageApproval,
} from "../api";
import JobCard from "./JobCard";
import { GalleryImageCard } from "../SuperGallery/GalleryImageCard";
import { GalleryVideoCard } from "../SuperGallery/GalleryVideoCard";

export default function ModGallery() {
  const [galleryImages, setGalleryImages] = useState({});
  const [focusedImage, setFocusedImage] = useState({});
  const [activePage, setPage] = useState(1);
  const [showWatermarked, setShowWatermarked] = useState(false);
  const [userFilter, setUserFilter] = useState("");
  const [tagsFilter, setTagsFilter] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [jobDetails, setJobDetails] = useState([]);
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const pageSize = 9;

  // useEffect(() => {
  //   if (focusedImage) {
  //     setJobDetails([]);
  //     setJobDetailsLoading(true);
  //     getJobsForResultImage(focusedImage.logicalImageId).then((data) => {
  //       setJobDetails(data);
  //       setJobDetailsLoading(false);
  //     });
  //   }
  // }, [focusedImage]);

  useEffect(() => {
    setFocusedImage({});
    setIsLoading(true);
    // setGalleryImages({});
    fetchGalleryModerator(activePage, pageSize, userFilter, tagsFilter).then(
      (data) => {
        console.debug("Got gallery", data?.data?.length);
        setGalleryImages(data);
        setIsLoading(false);
      }
    );
  }, [activePage, userFilter, tagsFilter]);

  let handleDeleteImage = () => {
    setIsDeleting(true);
    deleteImage(focusedImage.logicalImageId).then(() => {
      var newGalleryImages = {
        ...galleryImages,
        data: galleryImages.data.filter(
          (p) => p.logicalImageId != focusedImage.logicalImageId
        ),
        totalCount: galleryImages.totalCount - 1,
      };
      console.debug("galler images:", galleryImages);

      console.debug("new gal images:", newGalleryImages);
      setGalleryImages(newGalleryImages);
      setFocusedImage({});
      setIsDeleting(false);
    });
  };

  return (
    <Container my="md" fluid>
      <Grid>
        <Grid.Col span={10}>
          <Group>
            <Pagination
              total={Math.ceil(galleryImages.totalCount / pageSize)}
              value={activePage}
              onChange={setPage}
              mt="sm"
            />
            <Radio.Group
              value={userFilter}
              onChange={setUserFilter}
              name="userFilter"
              label="Select user filter"
            >
              <Radio label="All" value="" />
              <Radio label="Admin" value="Admin" />
              <Radio label="User" value="User" />
            </Radio.Group>
            <TagsInput data={[]} value={tagsFilter} onChange={setTagsFilter} />
            <Switch
              checked={showWatermarked}
              onChange={(event) =>
                setShowWatermarked(event.currentTarget.checked)
              }
              label="Show Watermarked"
            />
          </Group>
        </Grid.Col>
        <Grid.Col span={2}>
          <Text fw={500} size="lg">
            Moderation Tools
          </Text>
        </Grid.Col>

        <Grid.Col span={5}>
          <ScrollAreaAutosize style={{ maxHeight: "80dvh" }}>
            <Box pos="relative">
              <LoadingOverlay
                visible={isLoading}
                zIndex={1000}
                overlayProps={{ radius: "sm", blur: 2 }}
              />
              <SimpleGrid cols={3}>
                {galleryImages?.data?.map((image) =>
                  image.videoUrl ? (
                    <GalleryVideoCard
                      key={image.logicalImageId}
                      // selectionMode={selectedImages.length > 0}
                      // onDelete={onDelete}
                      // checked={selectedImages.includes(image.logicalImageId)}
                      // onCheckedChange={(checked) => {
                      //   if (checked)
                      //     setSelectedImages([
                      //       ...selectedImages,
                      //       image.logicalImageId,
                      //     ]);
                      //   else
                      //     setSelectedImages(
                      //       selectedImages.filter(
                      //         (id) => id !== image.logicalImageId
                      //       )
                      //     );
                      // }}
                      onClick={() => {
                        setFocusedImage(image);
                        // setImageData(image);
                        // setLocation(image.videoUrl ? "/video" : "/editor");
                      }}
                      image={image}
                    />
                  ) : (
                    <GalleryImageCard
                      mah={200}
                      key={image.logicalImageId}
                      // selectionMode={selectedImages.length > 0}
                      // onDelete={onDelete}
                      // checked={selectedImages.includes(image.logicalImageId)}
                      // onCheckedChange={(checked) => {
                      //   if (checked)
                      //     setSelectedImages([
                      //       ...selectedImages,
                      //       image.logicalImageId,
                      //     ]);
                      //   else
                      //     setSelectedImages(
                      //       selectedImages.filter(
                      //         (id) => id !== image.logicalImageId
                      //       )
                      //     );
                      // }}
                      onClick={() => {
                        setFocusedImage(image);
                        // setImageData(image);
                        // setImageData({
                        //   thumbnailUri: image.uri,
                        //   uri: image.fullsizeUri,
                        //   id: image.logicalImageId,
                        // });
                        // setLocation(image.videoUrl ? "/video" : "/editor");
                      }}
                      image={image}
                    />
                  )
                )}
              </SimpleGrid>
            </Box>
          </ScrollAreaAutosize>
        </Grid.Col>
        <Grid.Col span={5}>
          {/* <img
            style={{ maxWidth: "100%", maxHeight: "1024px" }}
            src={
              showWatermarked
                ? focusedImage.watermarkUri
                : focusedImage.fullsizeUri
            }
          /> */}
          <img
            style={{ maxWidth: "100%", maxHeight: "1024px" }}
            src={focusedImage?.pixelImages && focusedImage?.pixelImages?.length > 0 && focusedImage?.pixelImages[0].uri}
          />
          <Code block>{JSON.stringify(focusedImage, null, 2)}</Code>
        </Grid.Col>
        <Grid.Col span={2}>
          <Paper p="md" radius="sm" withBorder mb="md">
            {/* <Link target="_blank" to={`/mod/generator?logicalImageId=${focusedImage.logicalImageId}&initImageSha=${focusedImage.fullsizeSha}`}>Use in Generator</Link> */}
            <Button
              disabled={!focusedImage.logicalImageId}
              size="sm"
              mb="xs"
              mr="xs"
              color="blue"
              component="a"
              target="_blank"
              href={`/mod/generator?logicalImageId=${focusedImage.logicalImageId}&initImageSha=${focusedImage.fullsizeSha}`}
            >
              Use in Generate
            </Button>

            <Button
              disabled={!focusedImage.logicalImageId}
              size="sm"
              mb="xs"
              mr="xs"
              color="blue"
              component="a"
              target="_blank"
              href={`/admin/samplingruns/create?logicalImageId=${focusedImage.logicalImageId}&initImageSha=${focusedImage.fullsizeSha}`}
            >
              Use in Sampler
            </Button>

            <Button
              disabled={!focusedImage.logicalImageId || isDeleting}
              mb="xs"
              mr="xs"
              size="sm"
              loading={isDeleting}
              onClick={() => handleDeleteImage()}
            >
              Delete
            </Button>
            <Group>
              Approved:
              {focusedImage.isApproved ? (
                <Badge color="green">Yes</Badge>
              ) : (
                <Badge color="red">No</Badge>
              )}
            </Group>
            <br />
            {focusedImage.isApproved ? (
              <Button
                color="red"
                onClick={() => {
                  setImageApproval(focusedImage.logicalImageId, false).then(
                    () => {
                      focusedImage.isApproved = false;
                      setFocusedImage({ ...focusedImage, isApproved: false });
                    }
                  );
                }}
              >
                Disapprove
              </Button>
            ) : (
              <Button
                color="green"
                onClick={() => {
                  setImageApproval(focusedImage.logicalImageId, true).then(
                    () => {
                      focusedImage.isApproved = true;
                      setFocusedImage({ ...focusedImage, isApproved: true });
                    }
                  );
                }}
              >
                Approve
              </Button>
            )}
          </Paper>

          <Paper p="md" radius="sm" withBorder mb="md">
            {focusedImage.timestamp}
            <Text mb="sm">Tags</Text>
            <TagsInput
              disabled={!focusedImage.logicalImageId}
              data={[]}
              value={focusedImage.tags}
              onChange={(newTags) => {
                console.debug("tags changed", newTags);
                setFocusedImage({ ...focusedImage, tags: newTags });
              }}
            />
            <Button
              size="sm"
              mt="sm"
              disabled={!focusedImage.logicalImageId}
              onClick={() => {
                setImageMeta(focusedImage.logicalImageId, {
                  tags: focusedImage.tags,
                }).then(() => {
                  console.debug("Tags saved");
                });
              }}
            >
              Save
            </Button>
          </Paper>

          {jobDetailsLoading ? <Loader /> : null}
          {jobDetails.map((job) => (
            <JobCard key={job.id} job={job} />
          ))}

          <Paper p="md" radius="sm" withBorder mb="md">
            Quick Filter
            <Group gap="xs">
              {focusedImage.tags?.map((q) => (
                <Badge
                  onClick={() => {
                    setTagsFilter([...tagsFilter, q]);
                  }}
                  mr="xs"
                  key={q}
                >
                  {q}
                </Badge>
              ))}
            </Group>
          </Paper>
          {/* <Card>
              
              {JSON.stringify(jobDetails, null, 2)}
          </Card> */}
          <br />
        </Grid.Col>
      </Grid>

      {/* <SimpleGrid cols={3}>
        {galleryImages.map((img) => (
          <img  key={img.sha}  src={img.uri} style={{ maxWidth: '100%' }} />
        ))}
      </SimpleGrid> */}
    </Container>
  );
}
